import script from "./SliderNewMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderNewMobile.vue?vue&type=script&setup=true&lang=js"

import "./SliderNewMobile.vue?vue&type=style&index=0&id=f2df433e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2df433e"]])

export default __exports__